import { applySearch } from "./searching";
import { setAppLoadingPromise } from "./loading";

export const SET_IMMUTABLE_FILTERING_DATA = 'SET_IMMUTABLE_FILTERING_DATA';

export const ADD_FILTER = 'ADD_FILTER';
export const REMOVE_FILTER = 'REMOVE_FILTER';

export const CALCULATE_FILTERED_ROW_KEYS = 'CALCULATE_FILTERED_ROW_KEYS';
export const CALCULATE_AVAILABLE_OPTIONS = 'CALCULATE_AVAILABLE_OPTIONS';


export function setImmutableFilteringData(fields, options) {
    return {
        type: SET_IMMUTABLE_FILTERING_DATA,
        fields,
        options,
    }
}

export function addFilterAndApply(field, value) {
    /**
     * Action that adds a filter then applies the newly update filters to the data.
     *
     * */
    return function (dispatch) {
        return new Promise(function (resolve, reject) {
            dispatch( addFilter(field, value) )
            resolve()
        }).then( () => dispatch( applyFilters() ) )
    }
}

function addFilter(field, value) {
    return {
        type: ADD_FILTER,
        field,
        value
    }
}

export function removeFilterAndApply(field, value) {
    /**
     * Action that removes a filter then applies the newly updates filters to the data.
     *
     * */
    return function (dispatch) {
        return new Promise(function (resolve, reject) {
            dispatch( removeFilter(field, value) );
            resolve()
        }).then( () => dispatch( applyFilters() ) )
    }
}

function removeFilter(field, value) {
    return {
        type: REMOVE_FILTER,
        field,
        value
    }
}

export function applyFilters() {
    /**
     * Combines actions required to apply active filters to the data set.
     *
     * */

    return function (dispatch, getState) {
        dispatch( setAppLoadingPromise() )
        .then(() => {
            return new Promise(function (resolve, reject) {

                const {immutableBaseData, immutableFiltering, mutableBaseData} = getState();
                // these two dispatches can run in any order, it's fine.
                dispatch(calculateFilteredRowKeys(
                    mutableBaseData.rows,
                    immutableBaseData.rowKeys
                ));
                dispatch(calculateAvailableOptions(
                    immutableFiltering.fields,
                    immutableFiltering.options
                ));

                resolve()
            })
        })
        .then(() => dispatch( applySearch() ))  // we updated the filtered data so we need to redo the search.
    }
}

function calculateFilteredRowKeys(rows, initialRowKeys) {
    return {
        type: CALCULATE_FILTERED_ROW_KEYS,
        rows,
        initialRowKeys
    }
}

function calculateAvailableOptions(fields, initialOptions) {
    return {
        type: CALCULATE_AVAILABLE_OPTIONS,
        fields,
        initialOptions
    }
}
